/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineTopAppliedFilters_user = {
    readonly " $fragmentRefs": FragmentRefs<"useMeasurementUnit_user">;
    readonly " $refType": "SbRespRefineTopAppliedFilters_user";
};
export type SbRespRefineTopAppliedFilters_user$data = SbRespRefineTopAppliedFilters_user;
export type SbRespRefineTopAppliedFilters_user$key = {
    readonly " $data"?: SbRespRefineTopAppliedFilters_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineTopAppliedFilters_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineTopAppliedFilters_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "measurementUnit",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '621345bc73e2beb83b46f384c1d397a9';
export default node;
